/* main js */
import "bootstrap";
import scrollHandler from "./scrollHandler";
import "./swiper"
import scrollObserver from "./scrollObserver";
import {startPageOnTop} from "./utilities";

window.addEventListener('DOMContentLoaded', () => {
    startPageOnTop();
    scrollHandler();
    /**
     * Sliders on scroll
     */
    const sliders = document.querySelectorAll('.slider');
    if (sliders?.length) {
        scrollObserver({items: sliders, rootMargin: "-250px 0px"})
    }
    /**
     * Title block script
     * @type {Element}
     */
    const titleBlocks = document.querySelectorAll('.title-block.has-fill-animation');
    if (titleBlocks?.length) {
        import('./titleBlock').then(module => {
            module.default();
        });
    }
    /**
     * Description block script
     * @type {Element}
     */
    const numberDescriptionBlocks = document.querySelectorAll('.number-description');
    if (numberDescriptionBlocks?.length) {
        import('./numberDescription').then(module => {
            module.default(numberDescriptionBlocks);
        });
    }
})